import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.grey[200],
    padding: 16,
    borderRadius: 8,
    marginBottom: 16
  },
  header: { display: 'flex', flexDirection: 'row' },
  imageContainer: {
    display: 'flex',
    width: '240px',
    minWidth: '240px',
    maxWidth: '240px',
    height: '170px',
    [theme.breakpoints.down('sm')]: {
      width: '100px',
      height: '100px',
      minWidth: '100px',
      maxWidth: '100px'
    },
    position: 'relative',
    marginRight: 8
  },
  imageContainerPointer: {
    cursor: 'pointer'
  },
  image: { objectFit: 'fill', width: '100%', height: '100%', borderRadius: 6 },
  details: { display: 'flex', flexDirection: 'column', padding: 1 },
  individual: {
    display: 'flex',
    margin: '8px 0',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  guest: {
    display: 'flex',
    marginRight: 8,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 8
    }
  },
  icon: { marginRight: 6, fontSize: 18, alignSelf: 'center' },
  facilityContainer: { display: 'flex', flexWrap: 'wrap' },
  content: {
    display: 'flex',
    flexDirection: 'column',
    margin: '10px 0px',
    border: `1px solid ${theme.palette.grey[400]}`,
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    [theme.breakpoints.down('sm')]: {
      border: 'none',
      marginBottom: 0
    },
    marginTop: 18
  },
  tableHeader: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    background: theme.palette.grey[200],
    padding: '8px 16px',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px'
  },
  left: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: 12,
    border: `1px solid ${theme.palette.grey[200]}`,
    background: theme.palette.background.default,
    gap: 3
  },
  ratePlanTitle: { display: 'flex', alignItems: 'center' },
  headerforRateplans: { marginBottom: 8 },
  policy: { display: 'flex', alignItems: 'center' },
  ratePolicy: { display: 'flex', alignItems: 'center' },
  redIcon: { color: theme.palette.error.main, fontSize: 18, marginRight: 4 },
  blueIcon: { color: theme.palette.info.main, fontSize: 18, marginRight: 4 },
  greenIcon: {
    color: theme.palette.secondary.main,
    fontSize: 18,
    marginRight: 4
  },
  yellowIcon: {
    color: theme.palette.warning.main,
    fontSize: 18,
    marginRight: 4
  },
  redtext: {
    color: theme.palette.error.main,
    marginRight: 10,
    fontWeight: 600
  },
  yellowText: {
    color: theme.palette.warning.main,
    marginRight: 10,
    fontWeight: 600
  },
  blueText: {
    color: theme.palette.info.main,
    marginRight: 10,
    fontWeight: 600
  },
  greenIconText: {
    color: theme.palette.secondary.main,
    marginRight: 10,
    fontWeight: 600
  },
  infoIcon: { marginRight: 6, fontSize: 14, padding: 0 },
  middle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: 12,
    border: `1px solid ${theme.palette.grey[200]}`,
    background: theme.palette.background.default,
    gap: 3
  },
  price: { display: 'flex', alignItems: 'center' },
  discount: {
    background: theme.palette.grey[200],
    padding: 5,
    borderRadius: 7,
    width: 'fit-content'
  },
  blackFontWeight: { fontWeight: 600, color: theme.palette.text.primary },
  greyFontWeight: { fontWeight: 600, color: theme.palette.grey[600] },
  greenText: { color: theme.palette.secondary.main, fontWeight: 400 },
  right: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 12,
    border: `1px solid ${theme.palette.grey[200]}`,
    background: theme.palette.background.default
  },
  formcontrol: { marginLeft: 0 },
  headerText: {
    color: theme.palette.grey[700],
    fontWeight: 600,
    alignSelf: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },
  discountText: {
    color: theme.palette.error.main,
    fontWeight: 600,
    textDecoration: 'line-through'
  },
  sub: {
    color: theme.palette.grey[800],

    [theme.breakpoints.down('sm')]: {
      fontSize: 13
    }
  },
  middleText: {
    textAlign: 'center'
  },
  showMore: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 600
  },
  counter: {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    background: theme.palette.grey[900],
    position: 'absolute',
    top: 10,
    left: 10,
    padding: '4px 8px',
    borderRadius: 6,
    opacity: 0.6
  },
  photoIcon: { width: 14, height: 14, marginRight: 2 },

  iconText: {
    lineHeight: 1,
    fontWeight: 600,
    color: theme.palette.primary.contrastText,
    marginLeft: 6
  },
  text: { fontWeight: 600, marginTop: 6 },
  btn: {
    textTransform: 'none',
    padding: 0,
    fontSize: 14,
    marginLeft: 4,
    display: 'inline',
    minWidth: 'auto',
    color: theme.palette.info.main
  }
}))
export default useStyles
